import { useMutation } from '@tanstack/react-query'

import { AxiosError } from 'axios'
import {
  CreatePolicyholderEntityClientRequest,
  CreatePolicyholderEntityClientResponse,
} from '../../@types/CreatePolicyholderEntity'
import { ErrorHandling } from '../../@types/ErrorHandling'
import { ENV } from '../../Environment'
import { api } from '../../Services/API'
import { useCreatePolicyHolderEntityStore } from '../../Stores/useCreatePolicyholderEntityStore'
import { API_ROUTES } from '../../constants/apiRoutes'
import { useErrorRequest } from '../useErrorRequest'

const headers = {
  'aip-company': ENV().CreatePolicyholder.Company,
}

const request = async (payload: CreatePolicyholderEntityClientRequest) => {
  const response = await api.post<CreatePolicyholderEntityClientResponse>(
    API_ROUTES.createPolicyholderEntity,
    payload,
    { headers },
  )

  return response.data
}

export const useCreatePolicyholderEntity = () => {
  const { setCreatePolicyHolderEntity } = useCreatePolicyHolderEntityStore()
  const { handleErrorRequest } = useErrorRequest()

  return useMutation({
    mutationFn: (payload: CreatePolicyholderEntityClientRequest) =>
      request(payload!),
    onSuccess(data) {
      setCreatePolicyHolderEntity(data)
    },
    onError(error: AxiosError<ErrorHandling[]>) {
      handleErrorRequest({ error })
    },
  })
}
